import TinyTile from "./TinyTile";
export default TinyTile;